if (!customElements.get("custom-videos")) {
  class CustomVideos extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      const windowsWidth = window.innerWidth;
      const enableSlider = this.dataset.enableSlider === "true";
      if (!enableSlider && windowsWidth > 767) return;
      const wrapper = this.querySelector("[data-wrapper]");
      wrapper.classList.add("swiper-wrapper");
      this.initSlider();
    }

    initSlider() {
      const autoplay = this.dataset.enableAutoplay === "true";
      const autoplaySpeed = this.dataset.autoplaySpeed;
      const items = parseInt(this.dataset.items);
      const slideContainer = this.querySelector(".swiper-container");
      if (slideContainer) {
        this.slider = new MinimogLibs.Swiper(slideContainer, {
          slidesPerView: 4,
          slidesPerGroup: 1,
          autoplay: autoplay
            ? {
                delay: parseInt(autoplaySpeed) * 1000,
              }
            : false,
          loop: true,
          navigation: {
            nextEl: this.querySelector(".swiper-button-next"),
            prevEl: this.querySelector(".swiper-button-prev"),
          },
          pagination: {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          },
          breakpoints: {
             320: {  
              slidesPerView: 1
            },
             430: {  
              slidesPerView: items > 2 ? 2 : items,
            },
            768: {
              slidesPerView: items > 3 ? 3 : items,
            },
            1024: {
              slidesPerView: items,
            },
          },
        });
      }
    }
  }

  customElements.define("custom-videos", CustomVideos);
}